import { FPTICommonData } from '../types/common'
import serverData from '../utils/server-data'

declare global {
  interface Window {
    PAYPAL: any
    fpti: any
  }
}

type FPTI = {
  recordImpression: (payload: unknown) => void
  recordClick: (payload: unknown) => void
} | null

type FPTI_EVENT = {
  type: string
  payload: unknown
}

class Analytics {
  static analytics: FPTI
  static initialized: boolean
  static eventQueue: FPTI_EVENT[] = []

  private getInstance() {
    if (!Analytics.analytics) {
      Analytics.analytics =
        window?.PAYPAL?.analytics?.instance ||
        new window.PAYPAL.analytics.Analytics()
    }
    return Analytics.analytics
  }

  private clean(data: any) {
    Object.keys(data).forEach((key) => {
      delete window?.fpti?.[key]
    })
  }

  private isCompleteSetup() {
    if (Analytics.initialized || !this.getInstance()) {
      return false
    }
    Analytics.initialized = true
    return true
  }

  public init() {
    if (window?.PAYPAL?.analytics && !window.PAYPAL.analytics.setupComplete) {
      window.PAYPAL.analytics.setupComplete = this.isCompleteSetup()
    } else {
      Analytics.initialized = true
      this.isCompleteSetup()
    }
  }

  /* eslint-disable complexity */
  private getCommonData(): FPTICommonData {
    return {
      devc_type: serverData?.deviceDetails?.deviceType,
      client_os: serverData?.deviceDetails?.deviceOS,
      browser_type: serverData?.deviceDetails?.browserName,
      cust: serverData?.ppRef,
      rsta: serverData?.locality?.locale,
      ccpg: serverData?.locality?.country,
      utm_source: serverData?.nonPiiQueryParams?.utm_source || '',
      utm_medium: serverData?.nonPiiQueryParams?.utm_medium || '',
      utm_campaign: serverData?.nonPiiQueryParams?.utm_campaign || '',
      utm_content: serverData?.nonPiiQueryParams?.utm_content || '',
      utm_unptid: serverData?.nonPiiQueryParams?.utm_unptid || '',
      utm_term: serverData?.nonPiiQueryParams?.utm_term || '',
      sfmc_id: serverData?.nonPiiQueryParams?.sfmc_id || '',
      internal_user: serverData?.nonPiiQueryParams?.internal_user || '',
      unptid: serverData?.nonPiiQueryParams?.unptid || '',
      product: 'app',
      ref_tsrce:
        serverData?.nonPiiQueryParams?.source ||
        serverData?.nonPiiQueryParams?.src ||
        '', // App download source
      tsrce: serverData?.nonPiiQueryParams?.tsrce || '', // App download traffic source
      ref_vid: serverData?.ppRef, // App download reference id (Payer ID / Visitor ID)
      source:
        serverData?.nonPiiQueryParams?.source ||
        serverData?.nonPiiQueryParams?.src ||
        '', // Page source
      calc: serverData?.calId, // Correlation ID
      pp_ref_id:
        serverData?.ppRefId || serverData?.nonPiiQueryParams?.pp_ref_id || '',
      xe: serverData?.nonPiiQueryParams?.xe || '',
      xt: serverData?.nonPiiQueryParams?.xt || '',
    }
  }

  public trackImpression(payload?: Record<string, unknown>) {
    if (Analytics.initialized) {
      this.getInstance()?.recordImpression({
        data: {
          ...this.getCommonData(),
          ...payload,
        },
      })
      this.clean(payload)
    }
  }
  public trackClick(payload?: Record<string, unknown>) {
    if (Analytics.initialized) {
      this.getInstance()?.recordClick({
        data: {
          ...this.getCommonData(),
          ...payload,
        },
      })
      this.clean(payload)
    }
  }
  public trackMORS(url: string) {
    const xmlhttp = new XMLHttpRequest()
    xmlhttp.open('GET', url, true)
    xmlhttp.send()
  }
  public reset() {
    Analytics.initialized = false
  }
}

export default new Analytics()
